// Environment variable configuration
const getEnvVar = (key) => {
  if (typeof window !== 'undefined' && window._env_ && window._env_[key]) {
    return window._env_[key];
  }
  return typeof process !== 'undefined' && process.env ? process.env[key] : undefined;
};

window._env_ = {
  // Default environment variables
  REACT_APP_SQUARE_ENVIRONMENT: 'production',
  REACT_APP_SQUARE_APP_ID: getEnvVar('REACT_APP_SQUARE_APP_ID'),
  REACT_APP_SQUARE_LOCATION_ID: getEnvVar('REACT_APP_SQUARE_LOCATION_ID'),
  REACT_APP_SQUARE_ACCESS_TOKEN: getEnvVar('REACT_APP_SQUARE_ACCESS_TOKEN'),
  
  // Firebase configuration
  REACT_APP_FIREBASE_API_KEY: getEnvVar('REACT_APP_FIREBASE_API_KEY'),
  REACT_APP_FIREBASE_AUTH_DOMAIN: getEnvVar('REACT_APP_FIREBASE_AUTH_DOMAIN'),
  REACT_APP_FIREBASE_PROJECT_ID: getEnvVar('REACT_APP_FIREBASE_PROJECT_ID'),
  REACT_APP_FIREBASE_STORAGE_BUCKET: getEnvVar('REACT_APP_FIREBASE_STORAGE_BUCKET'),
  REACT_APP_FIREBASE_MESSAGING_SENDER_ID: getEnvVar('REACT_APP_FIREBASE_MESSAGING_SENDER_ID'),
  REACT_APP_FIREBASE_APP_ID: getEnvVar('REACT_APP_FIREBASE_APP_ID'),
};

// Freeze the environment to prevent modifications
Object.freeze(window._env_); 